import React from "react";
import * as s from "./FreeText.module.scss";
import { createMarkup } from "src/libs/utils";

interface Props {
  text: string;
}
export class FreeText extends React.Component<Props> {
  render() {
    const { text } = this.props;

    return (
      <div
        className={s.freeText}
        dangerouslySetInnerHTML={createMarkup(text)}
      />
    );
  }
}
